import type { TypedUseSelectorHook } from "react-redux"
import { useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "./store"

export const useAppDispatch: () => AppDispatch = useDispatch

/** Function that extracts a value from the store's root state */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
